import React from 'react';
import styled from 'styled-components';
import { Tabs } from 'antd';

const { TabPane } = Tabs;

const TabsWrapper = styled.div`
  margin-top: 16px;
  .ant-tabs-tab {
    padding: 10px 0;
  }
  .ant-tabs-nav {
    margin-bottom: 16px;
  }
`;

export type ContentTabItem = {
  /** The unique key for the tab. */
  key: string;
  header: React.ReactNode;
  content: React.ReactNode;
  tabPanelTestId?: string;
};

export type ContentTabsProps = {
  tabs: ContentTabItem[];
  tabsTestId?: string;
  initialActiveKey?: string; // When omitted, the first tab is selected by default
};

const ContentTabs: React.FC<ContentTabsProps> = ({ tabs, tabsTestId, initialActiveKey }) => {
  if (tabs.length === 0) {
    return null;
  }
  const initialKey = initialActiveKey ?? tabs[0]?.key;

  return (
    <TabsWrapper>
      <Tabs defaultActiveKey={initialKey} data-testid={tabsTestId}>
        {tabs.map(({ key, header, content, tabPanelTestId }) => (
          <TabPane key={key} tab={header} data-testid={tabPanelTestId}>
            {content}
          </TabPane>
        ))}
      </Tabs>
    </TabsWrapper>
  );
};

ContentTabs.displayName = 'ContentTabs';

export default ContentTabs;
